import { graphql, Link, useStaticQuery } from 'gatsby';
import { ImageDataLike } from 'gatsby-plugin-image';
import React, { FC } from 'react';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
export const DealsPopup: FC = () => {
  const data: {
    contentfulReviewPage: {
      contentReferences: Array<{
        id: string;
        product: {
          name: string;
          url: { url: string };
          imageReference: { image: ImageDataLike };
        };
      }>;
    };
  } = useStaticQuery(graphql`
    {
      contentfulReviewPage(slug: { eq: "tilbud" }) {
        slug
        contentReferences {
          ... on ContentfulProductReview {
            id
            product {
              name
              url {
                url
              }
              imageReference {
                image {
                  gatsbyImageData(
                    width: 50
                    layout: CONSTRAINED
                    placeholder: BLURRED
                  )
                }
              }
            }
          }
        }
      }
    }
  `);
  const { contentReferences } = data.contentfulReviewPage;

  return (
    <Wrapper>
      <Link to="/tilbud/">
        <NewReleasesIcon />
        TILBUD
      </Link>
      {/* {contentReferences.map(item => (
    //     <div key={item.id}>
    //       <p>{item.product.name}</p>
    //       <GatsbyImage
    //         image={getImage(item.product.imageReference.image)}
    //         alt=""
    //       />
    //     </div>
    //   ))} */}
    </Wrapper>
  );
};
const gradient = keyframes` 
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position:  100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
`;

const Wrapper = styled.div`
  padding: 12px;
  background: linear-gradient(-45deg, #ee7752, #e73c7e, rgb(180, 213, 35), #9dff00);
  background-size: 400% 400%;
  animation: ${gradient} 15s ease infinite;  

  a {
    padding: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  svg {
    margin-right: 6px;
    color: red;
  }
`;
